<template>
  <div>
    <v-checkbox
      v-model="modelValue.emailSubjectKeywordsEnabled"
      :disabled="disabled"
      data-testid="custom-data-monitor-passwords-checkbox"
      :ripple="false"
      :label="$t('userDataGovernanceSettings.exclusionsTab.excludeEmailsWithKeywords')"
      class="mt-3 mb-1"
    />
    <v-combobox
      :disabled="disabled || !modelValue.emailSubjectKeywordsEnabled"
      v-model="modelValue.emailSubjectKeywords"
      data-testid="custom-data-monitor-keywords-combobox"
      variant="outlined"
      multiple
      class="ml-7"
      :rules="sensitiveKeywordsRule"
      :placeholder="$t('userDataGovernanceSettings.exclusionsTab.specificKeywordsPlaceholder')"
      :aria-label="$t('userDataGovernanceSettings.exclusionsTab.specificKeywordsPlaceholder')"
      @update:search="onKeywordInput"
    >
      <template v-slot:chip="{ props, item }">
        <v-chip
          v-bind="props"
          :closable="true"
          variant="flat"
          size="default"
          close-icon="$closeCircle"
          :text="item.title"
          color="indigo-faint"
        >
          <div class="d-flex align-center">
            <span class="ml-1 mr-2">{{ item.title }}</span>
          </div>
        </v-chip>
      </template>
    </v-combobox>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { useI18n } from "vue-i18n";
import uniq from "lodash/uniq";
import type { UserDataGovernanceExclusions } from "@/_store/user-data-governance/user-data-governance.module";

export default defineComponent({
  name: "EmailSubjectKeywordsInput",
  props: {
    modelValue: {
      type: Object as PropType<UserDataGovernanceExclusions>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const i18n = useI18n();

    const sensitiveKeywordsRule = [
      (keywords: string[]) => {
        if (keywords?.length > 200) {
          return i18n.t("validations.maximumAllowedKeywords");
        }
        return true;
      },
    ];

    const onKeywordInput = () => {
      const value = props.modelValue.emailSubjectKeywords as string[];
      const updatedValue = {
        ...props.modelValue,
        emailSubjectKeywords: uniq(value.slice().map((keyword) => keyword.trim())),
      };
      emit("update:modelValue", updatedValue);
    };

    return {
      sensitiveKeywordsRule,
      onKeywordInput,
    };
  },
});
</script>

<style scoped lang="scss">
:deep(*) {
  .v-field .v-chip {
    --v-chip-height: 32px;
  }
}
</style>
